import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, isRef as _isRef, withModifiers as _withModifiers, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/icons/download-2.svg';
const _withScopeId = n => (_pushScopeId("data-v-4b415b61"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "campaign-email-form" };
const _hoisted_2 = { class: "campaign-email-form__header" };
const _hoisted_3 = { class: "campaign-email-form__title-header" };
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "campaign-email-form__subtitle" };
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = ["onSubmit"];
const _hoisted_10 = { class: "campaign-email-form__section" };
const _hoisted_11 = { class: "campaign-email-form__section-title" };
const _hoisted_12 = { class: "campaign-email-form__grid--details" };
const _hoisted_13 = { class: "campaign-email-form__field" };
const _hoisted_14 = { class: "campaign-email-form__label" };
const _hoisted_15 = { class: "required" };
const _hoisted_16 = { class: "campaign-email-form__field" };
const _hoisted_17 = { class: "campaign-email-form__label" };
const _hoisted_18 = { class: "required" };
const _hoisted_19 = ["innerHTML"];
const _hoisted_20 = { class: "campaign-email-form__section" };
const _hoisted_21 = { class: "campaign-email-form__section-title" };
const _hoisted_22 = { class: "campaign-email-form__grid--message" };
const _hoisted_23 = { class: "column-left" };
const _hoisted_24 = { class: "campaign-email-form__field" };
const _hoisted_25 = { class: "campaign-email-form__label-group" };
const _hoisted_26 = { class: "campaign-email-form__label" };
const _hoisted_27 = { class: "required" };
const _hoisted_28 = { class: "campaign-email-form__counter" };
const _hoisted_29 = { class: "campaign-email-form__field" };
const _hoisted_30 = { class: "campaign-email-form__label-group" };
const _hoisted_31 = { class: "campaign-email-form__label" };
const _hoisted_32 = { class: "campaign-email-form__counter" };
const _hoisted_33 = { class: "campaign-email-form__field" };
const _hoisted_34 = { class: "campaign-email-form__label" };
const _hoisted_35 = { class: "required" };
const _hoisted_36 = { class: "campaign-email-form__field" };
const _hoisted_37 = { class: "campaign-email-form__label" };
const _hoisted_38 = { class: "required" };
const _hoisted_39 = { class: "campaign-email-form__select-option" };
const _hoisted_40 = { class: "campaign-email-form__select-option-title" };
const _hoisted_41 = { class: "campaign-email-form__select-option-description" };
const _hoisted_42 = {
    key: 0,
    class: "campaign-email-form__load-file-row"
};
const _hoisted_43 = { class: "load-file" };
const _hoisted_44 = { class: "load-file__info" };
const _hoisted_45 = ["innerHTML"];
const _hoisted_46 = {
    key: 0,
    class: "load-file__size"
};
const _hoisted_47 = ["alt"];
const _hoisted_48 = { class: "insert-button" };
const _hoisted_49 = ["disabled"];
const _hoisted_50 = {
    key: 1,
    class: "load-file load-file--link"
};
const _hoisted_51 = { class: "load-file__info" };
const _hoisted_52 = { class: "campaign-email-form__label" };
const _hoisted_53 = { class: "insert-button" };
const _hoisted_54 = ["disabled"];
const _hoisted_55 = { class: "column-rigth" };
const _hoisted_56 = { class: "campaign-email-form__field" };
const _hoisted_57 = { class: "campaign-email-form__label" };
const _hoisted_58 = { class: "campaign-email-form__field" };
const _hoisted_59 = { class: "campaign-email-form__label-group" };
const _hoisted_60 = { class: "campaign-email-form__label campaign-email-form__label--with-tooltip" };
const _hoisted_61 = { class: "campaign-email-form__sender-tooltip-text" };
const _hoisted_62 = { class: "campaign-email-form__sender-tooltip-warning" };
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px el-tooltip__trigger campaign-email-form__tooltip-icon" }, null, -1));
const _hoisted_64 = { class: "campaign-email-form__email-domain-row" };
const _hoisted_65 = {
    key: 0,
    class: "campaign-email-form__field"
};
const _hoisted_66 = { class: "campaign-email-form__label-group" };
const _hoisted_67 = { class: "campaign-email-form__label" };
const _hoisted_68 = { class: "required" };
const _hoisted_69 = { class: "campaign-email-form__email-domain-row" };
const _hoisted_70 = {
    key: 1,
    class: "campaign-email-form__field"
};
const _hoisted_71 = { class: "campaign-email-form__label" };
const _hoisted_72 = { class: "campaign-email-form__template-field" };
const _hoisted_73 = { class: "campaign-email-form__template-header" };
const _hoisted_74 = { class: "campaign-email-form__label" };
const _hoisted_75 = { class: "required" };
const _hoisted_76 = { class: "campaign-email-form__template-editor" };
const _hoisted_77 = { class: "campaign-email-form__mode-tabs" };
const _hoisted_78 = ["innerHTML"];
const _hoisted_79 = {
    key: 0,
    class: "campaign-email-form__variables"
};
const _hoisted_80 = { class: "campaign-email-form__variables-title" };
const _hoisted_81 = { class: "campaign-email-form__variables-subtitle" };
const _hoisted_82 = { class: "campaign-email-form__variables-list" };
const _hoisted_83 = { class: "campaign-email-form__variables-label" };
const _hoisted_84 = ["onDragstart"];
const _hoisted_85 = { class: "campaign-email-form__section campaign-email-form__section--delivery" };
const _hoisted_86 = { class: "campaign-email-form__section-title" };
const _hoisted_87 = { class: "campaign-email-form__delivery" };
const _hoisted_88 = { class: "campaign-email-form__delivery-panel" };
const _hoisted_89 = { class: "campaign-email-form__delivery-title" };
const _hoisted_90 = { class: "campaign-email-form__radio-group" };
const _hoisted_91 = { class: "campaign-email-form__radio-card" };
const _hoisted_92 = {
    for: "campaign-email-delivery-type-one-time",
    class: "campaign-email-form__radio-label"
};
const _hoisted_93 = { class: "campaign-email-form__radio-title" };
const _hoisted_94 = { class: "campaign-email-form__radio-caption" };
const _hoisted_95 = { class: "campaign-email-form__radio-card" };
const _hoisted_96 = {
    for: "campaign-email-delivery-type-recurrent",
    class: "campaign-email-form__radio-label"
};
const _hoisted_97 = { class: "campaign-email-form__radio-title" };
const _hoisted_98 = { class: "campaign-email-form__radio-caption" };
const _hoisted_99 = { class: "campaign-email-form__delivery-panel" };
const _hoisted_100 = { class: "campaign-email-form__delivery-title" };
const _hoisted_101 = { class: "campaign-email-form__radio-group" };
const _hoisted_102 = {
    key: 0,
    class: "campaign-email-form__radio-card"
};
const _hoisted_103 = {
    for: "campaign-email-delivery-schedule-now",
    class: "campaign-email-form__radio-label"
};
const _hoisted_104 = { class: "campaign-email-form__radio-title" };
const _hoisted_105 = { class: "campaign-email-form__radio-caption" };
const _hoisted_106 = { class: "campaign-email-form__radio-card" };
const _hoisted_107 = {
    for: "campaign-email-delivery-schedule-later",
    class: "campaign-email-form__radio-label"
};
const _hoisted_108 = { class: "campaign-email-form__radio-title" };
const _hoisted_109 = { class: "campaign-email-form__radio-caption" };
const _hoisted_110 = {
    key: 0,
    class: "campaign-email-form__grid campaign-email-form__grid--schedule campaign-email-form__delivery-fields"
};
const _hoisted_111 = { class: "campaign-email-form__field" };
const _hoisted_112 = { class: "campaign-email-form__label" };
const _hoisted_113 = { class: "required" };
const _hoisted_114 = { class: "campaign-email-form__field" };
const _hoisted_115 = { class: "campaign-email-form__label" };
const _hoisted_116 = { class: "required" };
const _hoisted_117 = {
    key: 0,
    class: "campaign-email-form__recurrent-note"
};
const _hoisted_118 = { class: "campaign-email-form__footer" };
const _hoisted_119 = { class: "campaign-email-form__footer-left" };
const _hoisted_120 = ["src"];
const _hoisted_121 = { class: "campaign-email-form__button-back-label" };
const _hoisted_122 = { class: "campaign-email-form__footer-right" };
const _hoisted_123 = ["src"];
import { computed, onMounted, ref, toRef, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useToast } from 'vue-toastification';
import vSelect from 'vue-select';
import debounce from 'lodash/debounce';
import moment from 'moment';
import { useCampaignEmailForm } from '@/features/CampaignsEmail/composables/useCampaignEmailForm';
import { getAudiences } from '@/services/actions';
import { getCampaignCategories } from '@/features/CampaignsEmail/services/getCampaignCategories';
import { getBrandSettings } from '@/features/CampaignsEmail/services/getBrandSettings';
import { getEmailBalance } from '@/features/CampaignsEmail/services/getEmailBalance';
import { updateCampaign as updateCampaignRequest } from '@/features/CampaignsEmail/data/updateCampaign';
import { buildCampaignPayload } from '@/features/CampaignsEmail/utils/buildCampaignPayload';
import { useHtmlInsertion } from '@/features/CampaignsEmail/composables/useHtmlInsertion';
import { sanitizeHtml } from '@/features/CampaignsEmail/utils/sanitizeHtml';
import SendTestEmailDialog from '@/features/CampaignsEmail/components/SendTestEmailDialog.vue';
import { useOpenSendTestEmailDialog } from '@/features/CampaignsEmail/composables/useOpenSendTestEmailDialog';
import { useEmailCampaignListNavigation } from '@/features/CampaignsEmail/composables/useEmailCampaignListSync';
import { formatDecimal } from '@/utilities/formatters/decimal';
import { formatDate } from '@/utilities/formatters/dates';
import { isValidEmailSyntax } from '@/utilities/validators/email';
import { disabledBackwardDates } from '@/utilities/datepicker';
import sendEmailTestIcon from '@/assets/svgs/SendEmailTest.svg';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CampaignEmailForm',
    props: {
        mode: {},
        id: {}
    },
    setup(__props) {
        const props = __props;
        const CREATION_TYPES = {
            UPLOAD: 'upload',
            LINK: 'link',
        };
        const isEdit = computed(() => props.mode === 'edit');
        const titleKey = computed(() => isEdit.value ? 'breadcrumb.email.email-campaign-edit' : 'breadcrumb.email.email-campaign-create');
        const hasHtmlTemplate = computed(() => {
            if (!state.settings.template)
                return false;
            const htmlPattern = /<html[^>]*>|<body[^>]*>|<!DOCTYPE/i;
            return htmlPattern.test(state.settings.template);
        });
        const decodeHtmlEntities = (input) => {
            if (!input)
                return '';
            const textarea = document.createElement('textarea');
            textarea.innerHTML = input;
            return textarea.value;
        };
        const templateForPreview = computed(() => {
            const raw = state.settings.template || '';
            const looksEncoded = /&lt;|&gt;|&#\d+;|&#x[a-fA-F0-9]+;/.test(raw);
            const decoded = looksEncoded ? decodeHtmlEntities(raw) : raw;
            return sanitizeHtml(decoded);
        });
        const isUploadCreation = computed(() => state.settings.creationType === CREATION_TYPES.UPLOAD);
        const isLinkCreation = computed(() => state.settings.creationType === CREATION_TYPES.LINK);
        const isHtmlCreation = computed(() => isUploadCreation.value || isLinkCreation.value);
        const isTemplateFullWidth = computed(() => false);
        const { goToList } = useEmailCampaignListNavigation();
        const { t } = useI18n();
        const toast = useToast();
        const showToast = {
            success: (message) => toast.success(message, { timeout: 3000 }),
            error: (message) => toast.error(message, { timeout: 4000 }),
            warning: (message) => toast.warning(message, { timeout: 5000 }),
        };
        const { state, save, loadCampaign } = useCampaignEmailForm();
        const dataLoaded = ref(false);
        const audienceOptions = ref([]);
        const categoryOptions = ref([]);
        const ipStrategyOptions = ref([]);
        const isLoadingIps = ref(false);
        const emailBalance = ref('0');
        const lastBalanceUpdate = ref('');
        const emailBalanceResetDate = ref('');
        const audienceCount = ref(0);
        const useDifferentReplyEmail = ref(false);
        const brandSenderEmail = ref('');
        const brandSenderName = ref('');
        const brandDomains = ref([]);
        const senderEmailLocalPart = ref('');
        const senderEmailDomain = ref('');
        const replyToEmailLocalPart = ref('');
        const replyToEmailDomain = ref('');
        const originalHtmlContent = ref(''); // Backup do HTML original carregado da API
        const fieldErrors = ref({}); // Estado de campos com erro
        const isSourceMode = ref(false);
        const templateVariables = ref([
            { label: 'Cliente', value: '{{customer_name}}' },
            { label: 'Loja', value: '{{store_name}}' },
            { label: 'Opt-out', value: '{{optout_url}}' },
        ]);
        const normalizeDomain = (domain) => domain.trim().replace(/^@/, '').toLowerCase();
        const splitEmail = (email) => {
            const trimmed = email?.trim() ?? '';
            const atIndex = trimmed.indexOf('@');
            if (atIndex === -1)
                return { local: trimmed, domain: '' };
            const local = trimmed.slice(0, atIndex);
            const domain = trimmed.slice(atIndex + 1);
            return { local, domain: normalizeDomain(domain) };
        };
        const buildEmail = (local, domain) => {
            const trimmedLocal = local.trim();
            const trimmedDomain = normalizeDomain(domain);
            if (!trimmedLocal || !trimmedDomain)
                return '';
            return `${trimmedLocal}@${trimmedDomain}`;
        };
        const isSettingSenderEmailParts = ref(false);
        const isSettingReplyToEmailParts = ref(false);
        const applySenderEmailParts = (email) => {
            const { local, domain } = splitEmail(email);
            isSettingSenderEmailParts.value = true;
            senderEmailLocalPart.value = local;
            if (domain) {
                senderEmailDomain.value = domain;
            }
            isSettingSenderEmailParts.value = false;
        };
        const applyReplyToEmailParts = (email) => {
            const { local, domain } = splitEmail(email);
            isSettingReplyToEmailParts.value = true;
            replyToEmailLocalPart.value = local;
            if (domain) {
                replyToEmailDomain.value = domain;
            }
            isSettingReplyToEmailParts.value = false;
        };
        const domainOptions = computed(() => brandDomains.value.map(domain => ({
            label: `@${domain}`,
            value: domain,
        })));
        const isSingleDomain = computed(() => domainOptions.value.length === 1);
        const senderEmailFull = computed(() => buildEmail(senderEmailLocalPart.value, senderEmailDomain.value));
        const replyToEmailFull = computed(() => buildEmail(replyToEmailLocalPart.value, replyToEmailDomain.value));
        const senderEmailHasAtSymbol = computed(() => senderEmailLocalPart.value.includes('@'));
        const replyToEmailHasAtSymbol = computed(() => replyToEmailLocalPart.value.includes('@'));
        const senderEmailIsComplete = computed(() => senderEmailLocalPart.value.trim() !== '' && senderEmailDomain.value.trim() !== '');
        const replyToEmailIsComplete = computed(() => replyToEmailLocalPart.value.trim() !== '' && replyToEmailDomain.value.trim() !== '');
        const disabledMinutes = (selectedHour) => {
            const now = () => moment();
            const isToday = (date) => date.isSame(now(), 'day');
            const current = now();
            const isSameHour = selectedHour === current.hour();
            const isSameDay = state.settings.scheduleDate ? isToday(moment(state.settings.scheduleDate, 'YYYY-MM-DD')) : true;
            if (isSameDay && isSameHour) {
                return Array.from({ length: current.minute() }, (_, i) => i);
            }
            return [];
        };
        const disabledHours = () => {
            const now = () => moment();
            const isToday = (date) => date.isSame(now(), 'day');
            const current = now();
            const isSameDay = state.settings.scheduleDate ? isToday(moment(state.settings.scheduleDate, 'YYYY-MM-DD')) : true;
            if (!isSameDay)
                return [];
            if (current.hour() <= 0)
                return [];
            return Array.from({ length: current.hour() }, (_, i) => i);
        };
        const { insertionMethod: htmlInsertionMethod, htmlFile, htmlFileName, htmlFileSize, htmlUrl, htmlInserted, loadingHtml, fileInputRef, openFileDialog, handleFileChange, insertFromSelectedFile, loadFromUrl: loadHtmlFromUrl, reset: resetHtmlInsertion, } = useHtmlInsertion({
            template: toRef(state.settings, 'template'),
            t,
            toast: showToast,
        });
        const canInsertHtml = computed(() => {
            if (loadingHtml.value)
                return false;
            if (isUploadCreation.value)
                return !!htmlFile.value;
            if (isLinkCreation.value)
                return htmlUrl.value.trim().length > 0;
            return false;
        });
        const insertHtml = async () => {
            if (isUploadCreation.value) {
                await insertFromSelectedFile();
                return;
            }
            if (isLinkCreation.value) {
                await loadHtmlFromUrl();
            }
        };
        watch(() => state.settings.audienceId, audienceId => {
            const selected = audienceOptions.value.find(opt => opt.value === String(audienceId));
            audienceCount.value = selected ? selected.count : 0;
            if (audienceId && audienceId > 0 && audienceCount.value > 0 && fieldErrors.value.audienceId) {
                fieldErrors.value.audienceId = '';
            }
        }, { immediate: true });
        watch(() => state.settings.template, newTemplate => {
            if (isEdit.value && newTemplate && newTemplate.trim().length > 0 && isHtmlCreation.value)
                htmlInserted.value = true;
        }, { immediate: true });
        watch(() => state.settings.creationType, (newType, oldType) => {
            if (newType === oldType)
                return;
            if (newType === CREATION_TYPES.UPLOAD || newType === CREATION_TYPES.LINK) {
                htmlInsertionMethod.value = newType;
            }
            else {
                htmlInsertionMethod.value = null;
                resetHtmlInsertion();
                if (isEdit.value && originalHtmlContent.value) {
                    state.settings.template = originalHtmlContent.value;
                    htmlInserted.value = true;
                }
                else {
                    state.settings.template = '';
                    htmlInserted.value = false;
                }
            }
            // Limpa erro quando o campo for preenchido
            if (newType && fieldErrors.value.creationType) {
                fieldErrors.value.creationType = '';
            }
        });
        watch(() => state.settings.replyToEmail, newValue => {
            if (newValue && newValue.trim().length > 0 && newValue !== state.settings.senderEmail) {
                useDifferentReplyEmail.value = true;
            }
            // Limpa erro quando o campo for preenchido com email válido
            if (fieldErrors.value.replyToEmail && newValue && newValue.trim() !== '') {
                if (!replyToEmailHasAtSymbol.value && replyToEmailIsComplete.value && isValidEmail(newValue)) {
                    fieldErrors.value.replyToEmail = '';
                }
            }
        }, { immediate: true });
        watch(domainOptions, options => {
            if (options.length === 1) {
                const domain = options[0].value;
                if (!senderEmailDomain.value)
                    senderEmailDomain.value = domain;
                if (!replyToEmailDomain.value)
                    replyToEmailDomain.value = domain;
            }
        }, { immediate: true });
        watch([senderEmailLocalPart, senderEmailDomain], () => {
            if (isSettingSenderEmailParts.value)
                return;
            const next = senderEmailFull.value;
            if (next !== state.settings.senderEmail)
                state.settings.senderEmail = next;
        }, { flush: 'sync' });
        watch([replyToEmailLocalPart, replyToEmailDomain], () => {
            if (isSettingReplyToEmailParts.value)
                return;
            const next = replyToEmailFull.value;
            if (next !== state.settings.replyToEmail)
                state.settings.replyToEmail = next;
        }, { flush: 'sync' });
        watch(() => useDifferentReplyEmail.value, value => {
            if (!value) {
                isSettingReplyToEmailParts.value = true;
                replyToEmailLocalPart.value = '';
                replyToEmailDomain.value = '';
                isSettingReplyToEmailParts.value = false;
                state.settings.replyToEmail = '';
            }
        });
        // Watch centralizado para limpar erros dos campos quando forem preenchidos
        watch(() => ({
            name: state.settings.name,
            title: state.settings.title,
            senderName: state.settings.senderName,
            senderEmail: state.settings.senderEmail,
            categoryId: state.settings.categoryId,
            template: state.settings.template,
        }), newValues => {
            // Nome da campanha
            if (newValues.name && newValues.name.trim() !== '' && fieldErrors.value.name) {
                fieldErrors.value.name = '';
            }
            // Título/Assunto
            if (newValues.title && newValues.title.trim() !== '' && fieldErrors.value.title) {
                fieldErrors.value.title = '';
            }
            // Nome do remetente
            if (newValues.senderName && newValues.senderName.trim() !== '' && fieldErrors.value.senderName) {
                fieldErrors.value.senderName = '';
            }
            // Email do remetente
            if (fieldErrors.value.senderEmail && newValues.senderEmail && newValues.senderEmail.trim() !== '') {
                if (!senderEmailHasAtSymbol.value && senderEmailIsComplete.value && isValidEmail(senderEmailFull.value)) {
                    fieldErrors.value.senderEmail = '';
                }
            }
            // Categoria (aceita 0 como válido)
            if (newValues.categoryId !== null && newValues.categoryId !== undefined && fieldErrors.value.categoryId) {
                fieldErrors.value.categoryId = '';
            }
            // Template
            if (newValues.template && newValues.template.trim() !== '' && fieldErrors.value.template) {
                fieldErrors.value.template = '';
            }
        });
        const creationTypeOptions = computed(() => [
            {
                label: t('breadcrumb.email.campaign-form.fields.creation-type-upload-label'),
                description: t('breadcrumb.email.campaign-form.fields.creation-type-upload-description'),
                value: 'upload',
            },
            {
                label: t('breadcrumb.email.campaign-form.fields.creation-type-link-label'),
                description: t('breadcrumb.email.campaign-form.fields.creation-type-link-description'),
                value: 'link',
            },
        ]);
        const fetchAudiences = (searchTerm) => {
            const params = searchTerm ? { term: searchTerm, limit: undefined } : undefined;
            getAudiences(params).then(({ data }) => {
                if (data?.data) {
                    audienceOptions.value = data.data.map((audience) => ({
                        label: audience.name,
                        value: String(audience.id),
                        count: audience.count,
                    }));
                }
            });
        };
        const debouncedFetchAudiences = debounce((searchTerm) => {
            fetchAudiences(searchTerm);
        }, 500);
        const searchAudience = (term) => {
            if (!term) {
                fetchAudiences();
                return;
            }
            debouncedFetchAudiences(term);
        };
        const fetchCampaignCategories = async () => {
            try {
                const data = await getCampaignCategories();
                if (data && Array.isArray(data)) {
                    categoryOptions.value = data.map((category) => ({
                        label: category.name,
                        value: String(category.id),
                    }));
                }
            }
            catch (error) {
                categoryOptions.value = [];
                showToast.error('Erro ao buscar categorias de campanha.');
            }
        };
        const normalizeDomainList = (list) => {
            if (Array.isArray(list)) {
                return list
                    .map(item => {
                    if (typeof item === 'string')
                        return item;
                    if (item && typeof item === 'object') {
                        const domain = item.domain ?? item.name;
                        return domain ?? '';
                    }
                    return '';
                })
                    .map(item => normalizeDomain(item))
                    .filter(Boolean);
            }
            if (list && typeof list === 'object' && Array.isArray(list.result)) {
                return normalizeDomainList(list.result);
            }
            if (typeof list === 'string') {
                return list
                    .split(/[,\s]+/)
                    .map(item => normalizeDomain(item))
                    .filter(Boolean);
            }
            return [];
        };
        const extractDomains = (data) => {
            const candidates = [
                data.sender_domains,
                data.allowed_domains,
                data.authorized_domains,
                data.email_domains,
                data.domains,
            ];
            for (const candidate of candidates) {
                const normalized = normalizeDomainList(candidate);
                if (normalized.length > 0)
                    return normalized;
            }
            return [];
        };
        const setBrandDomains = (domains) => {
            const uniqueDomains = Array.from(new Set(domains.map(domain => normalizeDomain(domain)).filter(Boolean)));
            brandDomains.value = uniqueDomains;
        };
        const fetchBrandSettings = async () => {
            try {
                const data = await getBrandSettings();
                const domains = extractDomains(data);
                if (!domains.length && data?.sender_email) {
                    const { domain } = splitEmail(data.sender_email);
                    if (domain)
                        domains.push(domain);
                }
                setBrandDomains(domains);
                if (data?.sender_email) {
                    brandSenderEmail.value = data.sender_email;
                    if (!state.settings.senderEmail) {
                        state.settings.senderEmail = data.sender_email;
                        applySenderEmailParts(data.sender_email);
                    }
                }
                if (data?.sender_name) {
                    brandSenderName.value = data.sender_name;
                    if (!state.settings.senderName)
                        state.settings.senderName = data.sender_name;
                }
                if (data?.ips?.result && data.ips.result.length > 0) {
                    isLoadingIps.value = true;
                    ipStrategyOptions.value = [
                        { label: t('breadcrumb.email.campaign-form.fields.ip-balance-option'), value: '' },
                        ...data.ips.result.map((ip) => ({
                            label: ip.name,
                            value: ip.name,
                        })),
                    ];
                }
                else {
                    isLoadingIps.value = false;
                }
            }
            catch (error) {
                showToast.error(t('breadcrumb.email.campaigns.toasts.fetch-brand-settings-error'));
            }
        };
        const fetchEmailBalance = async () => {
            try {
                const data = await getEmailBalance();
                if (data) {
                    emailBalance.value = data.remaining !== undefined ? formatDecimal(data.remaining, 0) : '0';
                    if (data.last_synced_at)
                        lastBalanceUpdate.value = formatDate(data.last_synced_at, 'DD/MM/YYYY [às] HH:mm:ss');
                    if (data.period) {
                        const [year, month] = data.period.split('-').map(Number);
                        const lastDay = new Date(year, month, 0);
                        emailBalanceResetDate.value = formatDate(lastDay.toISOString(), 'DD/MM/YY');
                    }
                }
            }
            catch (error) {
                showToast.error(`Erro ao buscar saldo de e-mails`);
            }
        };
        onMounted(async () => {
            if (dataLoaded.value)
                return;
            state.loading = true;
            try {
                await Promise.all([fetchAudiences(), fetchCampaignCategories(), fetchBrandSettings(), fetchEmailBalance()]);
                if (isEdit.value && props.id) {
                    const campaignData = await loadCampaign(props.id);
                    // Preenche com valores da marca se não tiver dados na campanha
                    if (!state.settings.senderEmail || state.settings.senderEmail.trim() === '') {
                        state.settings.senderEmail = brandSenderEmail.value;
                    }
                    if (!state.settings.senderName || state.settings.senderName.trim() === '') {
                        state.settings.senderName = brandSenderName.value;
                    }
                    applySenderEmailParts(state.settings.senderEmail || brandSenderEmail.value);
                    applyReplyToEmailParts(state.settings.replyToEmail || '');
                    if (campaignData?.audience) {
                        addAudienceIfNotExists(campaignData.audience);
                        audienceCount.value = campaignData.audience.count;
                    }
                    if (campaignData?.category)
                        addCategoryIfNotExists(campaignData.category);
                    if (hasHtmlTemplate.value) {
                        originalHtmlContent.value = state.settings.template || '';
                        state.settings.creationType = null;
                    }
                }
                else {
                    // Criação: preenche com valores da marca
                    if (!state.settings.senderEmail)
                        state.settings.senderEmail = brandSenderEmail.value;
                    if (!state.settings.senderName)
                        state.settings.senderName = brandSenderName.value;
                    applySenderEmailParts(state.settings.senderEmail || brandSenderEmail.value);
                }
                dataLoaded.value = true;
            }
            catch (error) {
                const message = error instanceof Error ? error.message : 'Erro ao carregar dados';
                showToast.error(message);
            }
            finally {
                state.loading = false;
            }
        });
        const addAudienceIfNotExists = (audience) => {
            const exists = audienceOptions.value.some(opt => opt.value === String(audience.id));
            if (!exists) {
                audienceOptions.value.unshift({
                    label: audience.name,
                    value: String(audience.id),
                    count: audience.count,
                });
            }
        };
        const addCategoryIfNotExists = (category) => {
            const exists = categoryOptions.value.some(opt => opt.value === String(category.id));
            if (!exists) {
                categoryOptions.value.unshift({
                    label: category.name,
                    value: String(category.id),
                });
            }
        };
        watch(() => state.settings.isScheduled, value => {
            if (value === false) {
                state.settings.scheduleDate = null;
                state.settings.scheduleTime = null;
                fieldErrors.value.scheduleDate = '';
                fieldErrors.value.scheduleTime = '';
            }
        });
        watch(() => state.settings.scheduleDate, value => {
            if (value && fieldErrors.value.scheduleDate)
                fieldErrors.value.scheduleDate = '';
        });
        watch(() => state.settings.scheduleTime, value => {
            if (value && fieldErrors.value.scheduleTime)
                fieldErrors.value.scheduleTime = '';
        });
        watch(() => state.settings.isRecurrent, value => {
            if (value) {
                state.settings.isScheduled = true;
            }
        });
        const isValidEmail = (email) => isValidEmailSyntax(email);
        const isInvalidSenderEmail = computed(() => {
            if (!senderEmailLocalPart.value && !senderEmailDomain.value)
                return false;
            if (senderEmailHasAtSymbol.value)
                return true;
            if (!senderEmailIsComplete.value)
                return false;
            return !isValidEmail(senderEmailFull.value);
        });
        const isInvalidReplyToEmail = computed(() => {
            if (!replyToEmailLocalPart.value && !replyToEmailDomain.value)
                return false;
            if (replyToEmailHasAtSymbol.value)
                return true;
            if (!replyToEmailIsComplete.value)
                return false;
            return !isValidEmail(replyToEmailFull.value);
        });
        const senderEmailTouched = ref(false);
        const replyToEmailTouched = ref(false);
        const senderEmailTooltipShown = computed(() => senderEmailHasAtSymbol.value ||
            Boolean(fieldErrors.value.senderEmail) ||
            (senderEmailTouched.value && isInvalidSenderEmail.value));
        const senderEmailTooltipContent = computed(() => {
            if (senderEmailHasAtSymbol.value)
                return t('campaigns.email-with-domain-error');
            return fieldErrors.value.senderEmail || t('campaigns.invalid-email');
        });
        const senderEmailHasError = computed(() => isInvalidSenderEmail.value || Boolean(fieldErrors.value.senderEmail));
        const senderEmailDomainHasError = computed(() => Boolean(fieldErrors.value.senderEmail) && !senderEmailDomain.value);
        const replyToEmailTooltipShown = computed(() => replyToEmailHasAtSymbol.value ||
            Boolean(fieldErrors.value.replyToEmail) ||
            (replyToEmailTouched.value && isInvalidReplyToEmail.value));
        const replyToEmailTooltipContent = computed(() => {
            if (replyToEmailHasAtSymbol.value)
                return t('campaigns.email-with-domain-error');
            return fieldErrors.value.replyToEmail || t('campaigns.invalid-email');
        });
        const replyToEmailHasError = computed(() => isInvalidReplyToEmail.value || Boolean(fieldErrors.value.replyToEmail));
        const replyToEmailDomainHasError = computed(() => Boolean(fieldErrors.value.replyToEmail) && !replyToEmailDomain.value);
        const replyToEmailRequiredTooltipShown = computed(() => Boolean(fieldErrors.value.replyToEmail));
        const replyToEmailRequiredTooltipContent = computed(() => fieldErrors.value.replyToEmail);
        const handleCancel = () => {
            goToList();
        };
        const handleSenderEmailBlur = () => {
            senderEmailTouched.value = true;
            if (!senderEmailLocalPart.value || senderEmailLocalPart.value.trim() === '') {
                if (brandSenderEmail.value) {
                    state.settings.senderEmail = brandSenderEmail.value;
                    applySenderEmailParts(brandSenderEmail.value);
                }
            }
        };
        const handleReplyToEmailBlur = () => {
            replyToEmailTouched.value = true;
        };
        const handleSenderNameBlur = () => {
            if (!state.settings.senderName || state.settings.senderName.trim() === '')
                state.settings.senderName = brandSenderName.value;
        };
        const handleDragStart = (event, variableValue) => {
            const { dataTransfer } = event;
            if (dataTransfer) {
                dataTransfer.effectAllowed = 'copy';
                dataTransfer.setData('text/plain', variableValue);
            }
        };
        const { isTestEmailModalOpen, testTemplateForModal, openSendEmailTestDialog } = useOpenSendTestEmailDialog({
            title: toRef(state.settings, 'title'),
            template: toRef(state.settings, 'template'),
            creationType: toRef(state.settings, 'creationType'),
            htmlFile,
        });
        const sendEmailTest = () => {
            if (!senderEmailIsComplete.value || isInvalidSenderEmail.value) {
                senderEmailTouched.value = true;
                showToast.error(t('campaigns.invalid-email'));
                return;
            }
            if (useDifferentReplyEmail.value && (!replyToEmailIsComplete.value || isInvalidReplyToEmail.value)) {
                replyToEmailTouched.value = true;
                showToast.error(t('campaigns.invalid-email'));
                return;
            }
            return openSendEmailTestDialog();
        };
        const validateRequiredFields = () => {
            fieldErrors.value = {};
            let isValid = true;
            // Nome da campanha
            if (!state.settings.name || state.settings.name.trim() === '') {
                fieldErrors.value.name = t('campaigns.required-field');
                isValid = false;
            }
            if (state.settings.name.length < 5) {
                fieldErrors.value.name = t('breadcrumb.email.campaign-form.fields.name-min-length');
                isValid = false;
            }
            // Audiência (não permite 0 e não pode ser vazia)
            if (!state.settings.audienceId || state.settings.audienceId <= 0) {
                fieldErrors.value.audienceId = t('campaigns.required-field');
                isValid = false;
            }
            else if (audienceCount.value === 0) {
                fieldErrors.value.audienceId = t('breadcrumb.email.campaign-form.errors.empty-audience');
                isValid = false;
            }
            // Título/Assunto
            if (!state.settings.title || state.settings.title.trim() === '') {
                fieldErrors.value.title = t('campaigns.required-field');
                isValid = false;
            }
            // Email do remetente
            if (senderEmailHasAtSymbol.value) {
                isValid = false;
            }
            else if (!senderEmailIsComplete.value) {
                fieldErrors.value.senderEmail = t('campaigns.required-field');
                isValid = false;
            }
            else if (!isValidEmail(senderEmailFull.value)) {
                fieldErrors.value.senderEmail = t('campaigns.invalid-email');
                isValid = false;
            }
            // Email reply-to (se diferente do sender)
            if (useDifferentReplyEmail.value) {
                if (replyToEmailHasAtSymbol.value) {
                    isValid = false;
                }
                else if (!replyToEmailIsComplete.value) {
                    fieldErrors.value.replyToEmail = t('campaigns.required-field');
                    isValid = false;
                }
                else if (!isValidEmail(replyToEmailFull.value)) {
                    fieldErrors.value.replyToEmail = t('campaigns.invalid-email');
                    isValid = false;
                }
            }
            // Categoria (aceita 0 como valor válido)
            if (state.settings.categoryId === null || state.settings.categoryId === undefined) {
                fieldErrors.value.categoryId = t('campaigns.required-field');
                isValid = false;
            }
            // Tipo de criação
            if (!state.settings.creationType && !isEdit.value) {
                fieldErrors.value.creationType = t('campaigns.required-field');
                isValid = false;
            }
            else if (isHtmlCreation.value && !htmlInserted.value) {
                fieldErrors.value.template = t('campaigns.required-field');
                isValid = false;
            }
            // Template
            if (state.settings.template === null ||
                state.settings.template === undefined ||
                state.settings.template.trim() === '') {
                fieldErrors.value.template = t('campaigns.required-field');
                isValid = false;
            }
            // Agendamento: data e hora obrigatórios
            if (state.settings.isScheduled) {
                if (!state.settings.scheduleDate) {
                    fieldErrors.value.scheduleDate = t('campaigns.required-field');
                    isValid = false;
                }
                if (!state.settings.scheduleTime) {
                    fieldErrors.value.scheduleTime = t('campaigns.required-field');
                    isValid = false;
                }
                if (state.settings.scheduleDate && state.settings.scheduleTime) {
                    const scheduledAt = moment(`${state.settings.scheduleDate} ${state.settings.scheduleTime}`, 'YYYY-MM-DD HH:mm');
                    if (!scheduledAt.isValid() || scheduledAt.isSameOrBefore(moment())) {
                        showToast.error(t('breadcrumb.email.campaigns.toasts.schedule-past-error'));
                        isValid = false;
                    }
                }
            }
            return isValid;
        };
        const handleSubmit = async () => {
            if (state.saving)
                return;
            if (!validateRequiredFields())
                return;
            // Garante que senderName e senderEmail usem valores da marca se estiverem vazios
            if (!state.settings.senderName || state.settings.senderName.trim() === '') {
                state.settings.senderName = brandSenderName.value;
            }
            if (!state.settings.senderEmail || state.settings.senderEmail.trim() === '') {
                state.settings.senderEmail = brandSenderEmail.value;
            }
            state.saving = true;
            try {
                if (isEdit.value && props.id) {
                    const payload = buildCampaignPayload(state);
                    await updateCampaignRequest(payload, props.id);
                    showToast.success(t('360.campaigns.toast.updated'));
                }
                else {
                    const response = await save();
                    showToast.success(t('360.campaigns.toast.created'));
                    const createdId = String(state.lastSavedId ?? response?.data?.id ?? response?.data?.data?.id ?? '');
                    setTimeout(() => {
                        goToList(createdId || undefined);
                    }, 3000);
                    return;
                }
                setTimeout(() => {
                    goToList();
                }, 3000);
            }
            catch (error) {
                if (isEdit.value && props.id) {
                    showToast.error('Erro ao atualizar campanha');
                }
                else {
                    showToast.error('Erro ao salvar campanha');
                }
            }
            finally {
                state.saving = false;
            }
        };
        return (_ctx, _cache) => {
            const _component_el_skeleton = _resolveComponent("el-skeleton");
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_el_checkbox = _resolveComponent("el-checkbox");
            const _component_el_date_picker = _resolveComponent("el-date-picker");
            const _component_el_time_picker = _resolveComponent("el-time-picker");
            const _component_el_button = _resolveComponent("el-button");
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createVNode(_component_base_card_v2, { class: "campaign-email-form__base-card" }, {
                    default: _withCtx(() => [
                        _createElementVNode("header", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                (isEdit.value)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        class: "campaign-email-form__header-icon-arrow-left",
                                        src: require('@/assets/svgs/arrow.svg'),
                                        onClick: handleCancel,
                                        alt: _ctx.$t('_back-to-list')
                                    }, null, 8, _hoisted_4))
                                    : _createCommentVNode("", true),
                                _createElementVNode("img", {
                                    class: "campaign-email-form__icon",
                                    src: require('@/assets/svgs/email-campaign.svg'),
                                    alt: "",
                                    "aria-hidden": "true"
                                }, null, 8, _hoisted_5),
                                _createElementVNode("h1", null, _toDisplayString(_ctx.$t(titleKey.value)), 1)
                            ]),
                            _createElementVNode("p", _hoisted_6, [
                                (emailBalance.value && emailBalanceResetDate.value)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "text-left",
                                        innerHTML: _ctx.$t('breadcrumb.email.campaign.email-balance', {
                                            email_balance: emailBalance.value,
                                            email_balance_reset_date: emailBalanceResetDate.value,
                                        })
                                    }, null, 8, _hoisted_7))
                                    : _createCommentVNode("", true),
                                (lastBalanceUpdate.value)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 1,
                                        class: "text-right",
                                        innerHTML: _ctx.$t('breadcrumb.email.campaign.last-balance-update', {
                                            datetime: lastBalanceUpdate.value,
                                        })
                                    }, null, 8, _hoisted_8))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        (_unref(state).loading)
                            ? (_openBlock(), _createBlock(_component_el_skeleton, {
                                key: 0,
                                rows: 8,
                                animated: "",
                                class: "campaign-email-form__skeleton"
                            }))
                            : (_openBlock(), _createElementBlock("form", {
                                key: 1,
                                class: "campaign-email-form__form",
                                onSubmit: _withModifiers(handleSubmit, ["prevent"])
                            }, [
                                _createElementVNode("section", _hoisted_10, [
                                    _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.sections.details')), 1),
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("label", _hoisted_13, [
                                            _createElementVNode("span", _hoisted_14, [
                                                _createTextVNode(_toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.fields.campaign-name')) + " ", 1),
                                                _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_15, [
                                                    _createTextVNode("*")
                                                ])), [
                                                    [
                                                        _directive_tooltip,
                                                        {
                                                            theme: 'error',
                                                            shown: fieldErrors.value.name !== '',
                                                            content: fieldErrors.value.name,
                                                            distance: 8,
                                                            autoHide: false,
                                                        },
                                                        void 0,
                                                        { right: true }
                                                    ]
                                                ])
                                            ]),
                                            _createVNode(_component_el_input, {
                                                modelValue: _unref(state).settings.name,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(state).settings.name) = $event)),
                                                placeholder: _ctx.$t('breadcrumb.email.campaign-form.fields.campaign-name-placeholder'),
                                                class: _normalizeClass({ 'input-error': fieldErrors.value.name }),
                                                maxlength: "100"
                                            }, null, 8, ["modelValue", "placeholder", "class"])
                                        ]),
                                        _createElementVNode("label", _hoisted_16, [
                                            _createElementVNode("span", _hoisted_17, [
                                                _createTextVNode(_toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.fields.audience')) + " ", 1),
                                                _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_18, [
                                                    _createTextVNode("*")
                                                ])), [
                                                    [
                                                        _directive_tooltip,
                                                        {
                                                            theme: 'error',
                                                            shown: fieldErrors.value.audienceId !== '',
                                                            content: fieldErrors.value.audienceId,
                                                            distance: 8,
                                                            autoHide: false,
                                                        },
                                                        void 0,
                                                        { right: true }
                                                    ]
                                                ])
                                            ]),
                                            _createVNode(_unref(vSelect), {
                                                class: _normalizeClass(['campaign-email-form__select', { 'select-error': fieldErrors.value.audienceId }]),
                                                modelValue: _unref(state).settings.audienceId,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(state).settings.audienceId) = $event)),
                                                options: audienceOptions.value,
                                                label: "label",
                                                reduce: option => Number(option.value),
                                                placeholder: _ctx.$t('breadcrumb.email.campaign-form.fields.select-placeholder'),
                                                clearable: true,
                                                onSearch: searchAudience
                                            }, {
                                                "open-indicator": _withCtx(({ attributes }) => [
                                                    _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                                                ]),
                                                "no-options": _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(t)('no-results')), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["class", "modelValue", "options", "reduce", "placeholder"]),
                                            (_unref(state).settings.audienceId > 0)
                                                ? (_openBlock(), _createElementBlock("span", {
                                                    key: 0,
                                                    class: "text-audience-count",
                                                    innerHTML: audienceCount.value === 1
                                                        ? _ctx.$t('breadcrumb.email.campaign.audience-count-single', { audience_count: audienceCount.value })
                                                        : _ctx.$t('breadcrumb.email.campaign.audience-count-multiple', { audience_count: audienceCount.value })
                                                }, null, 8, _hoisted_19))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ]),
                                _createElementVNode("section", _hoisted_20, [
                                    _createElementVNode("h2", _hoisted_21, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.sections.message')), 1),
                                    _createElementVNode("div", _hoisted_22, [
                                        _createElementVNode("div", _hoisted_23, [
                                            _createElementVNode("label", _hoisted_24, [
                                                _createElementVNode("span", _hoisted_25, [
                                                    _createElementVNode("span", _hoisted_26, [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.fields.title-subject')) + " ", 1),
                                                        _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_27, [
                                                            _createTextVNode("*")
                                                        ])), [
                                                            [
                                                                _directive_tooltip,
                                                                {
                                                                    theme: 'error',
                                                                    shown: fieldErrors.value.title !== '',
                                                                    content: fieldErrors.value.title,
                                                                    distance: 8,
                                                                    autoHide: false,
                                                                },
                                                                void 0,
                                                                { right: true }
                                                            ]
                                                        ])
                                                    ])
                                                ]),
                                                _createVNode(_component_el_input, {
                                                    modelValue: _unref(state).settings.title,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(state).settings.title) = $event)),
                                                    placeholder: _ctx.$t('breadcrumb.email.campaign-form.fields.title-subject-placeholder'),
                                                    maxlength: "70",
                                                    class: _normalizeClass({ 'input-error': fieldErrors.value.title })
                                                }, null, 8, ["modelValue", "placeholder", "class"]),
                                                _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(state).settings?.title?.length || 0) + "/70", 1)
                                            ]),
                                            _createElementVNode("label", _hoisted_29, [
                                                _createElementVNode("span", _hoisted_30, [
                                                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.fields.sender-name')), 1)
                                                ]),
                                                _createVNode(_component_el_input, {
                                                    modelValue: _unref(state).settings.senderName,
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(state).settings.senderName) = $event)),
                                                    placeholder: _ctx.$t('breadcrumb.email.campaign-form.fields.sender-name-placeholder'),
                                                    maxlength: "50",
                                                    class: _normalizeClass({ 'input-error': fieldErrors.value.senderName }),
                                                    onBlur: handleSenderNameBlur
                                                }, null, 8, ["modelValue", "placeholder", "class"]),
                                                _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(state).settings?.senderName?.length || 0) + "/50", 1)
                                            ]),
                                            _createElementVNode("label", _hoisted_33, [
                                                _createElementVNode("span", _hoisted_34, [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.fields.category-label')) + " ", 1),
                                                    _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_35, [
                                                        _createTextVNode("*")
                                                    ])), [
                                                        [
                                                            _directive_tooltip,
                                                            {
                                                                theme: 'error',
                                                                shown: fieldErrors.value.categoryId !== '',
                                                                content: fieldErrors.value.categoryId,
                                                                distance: 8,
                                                                autoHide: false,
                                                            },
                                                            void 0,
                                                            { right: true }
                                                        ]
                                                    ])
                                                ]),
                                                _createVNode(_unref(vSelect), {
                                                    class: _normalizeClass(['campaign-email-form__select', { 'select-error': fieldErrors.value.categoryId }]),
                                                    modelValue: _unref(state).settings.categoryId,
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(state).settings.categoryId) = $event)),
                                                    options: categoryOptions.value,
                                                    label: "label",
                                                    reduce: option => Number(option.value),
                                                    placeholder: _ctx.$t('breadcrumb.email.campaign-form.fields.select-placeholder'),
                                                    clearable: true
                                                }, {
                                                    "open-indicator": _withCtx(({ attributes }) => [
                                                        _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                                                    ]),
                                                    "no-options": _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(t)('no-results')), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["class", "modelValue", "options", "reduce", "placeholder"])
                                            ]),
                                            _createElementVNode("label", _hoisted_36, [
                                                _createElementVNode("span", _hoisted_37, [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.fields.creation-type')) + " ", 1),
                                                    _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_38, [
                                                        _createTextVNode("*")
                                                    ])), [
                                                        [
                                                            _directive_tooltip,
                                                            {
                                                                theme: 'error',
                                                                shown: fieldErrors.value.creationType !== '',
                                                                content: fieldErrors.value.creationType,
                                                                distance: 8,
                                                                autoHide: false,
                                                            },
                                                            void 0,
                                                            { right: true }
                                                        ]
                                                    ])
                                                ]),
                                                _createVNode(_unref(vSelect), {
                                                    class: _normalizeClass(['campaign-email-form__select', { 'select-error': fieldErrors.value.creationType }]),
                                                    modelValue: _unref(state).settings.creationType,
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(state).settings.creationType) = $event)),
                                                    options: creationTypeOptions.value,
                                                    label: "label",
                                                    reduce: option => option.value,
                                                    placeholder: _ctx.$t('breadcrumb.email.campaign-form.fields.select-placeholder'),
                                                    clearable: false
                                                }, {
                                                    "selected-option": _withCtx(({ label }) => [
                                                        _createElementVNode("span", null, _toDisplayString(label), 1)
                                                    ]),
                                                    option: _withCtx((option) => [
                                                        _createElementVNode("div", _hoisted_39, [
                                                            _createElementVNode("div", _hoisted_40, _toDisplayString(option.label), 1),
                                                            _createElementVNode("div", _hoisted_41, _toDisplayString(option.description), 1)
                                                        ])
                                                    ]),
                                                    "open-indicator": _withCtx(({ attributes }) => [
                                                        _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                                                    ]),
                                                    "no-options": _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(t)('no-results')), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["class", "modelValue", "options", "reduce", "placeholder"]),
                                                (isHtmlCreation.value)
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        class: _normalizeClass([
                                                            'campaign-email-form__load-file',
                                                            { 'campaign-email-form__load-file--link': isLinkCreation.value },
                                                        ])
                                                    }, [
                                                        (isUploadCreation.value)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                                                _createElementVNode("input", {
                                                                    ref_key: "fileInputRef",
                                                                    ref: fileInputRef,
                                                                    type: "file",
                                                                    accept: ".html,.htm",
                                                                    style: { "display": "none" },
                                                                    onChange: _cache[6] || (_cache[6] =
                                                                        //@ts-ignore
                                                                        (...args) => (_unref(handleFileChange) && _unref(handleFileChange)(...args)))
                                                                }, null, 544),
                                                                _createElementVNode("div", _hoisted_43, [
                                                                    _createElementVNode("div", _hoisted_44, [
                                                                        _createElementVNode("span", {
                                                                            class: "load-file__text",
                                                                            innerHTML: _unref(htmlFileName) ? `<strong>${_unref(htmlFileName)}</strong>` : _unref(t)('campaigns.create.select-file')
                                                                        }, null, 8, _hoisted_45),
                                                                        (_unref(htmlFileName) && _unref(htmlFileSize))
                                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_unref(htmlFileSize)), 1))
                                                                            : _createCommentVNode("", true)
                                                                    ]),
                                                                    _createElementVNode("button", {
                                                                        type: "button",
                                                                        class: "load-file__button",
                                                                        onClick: _cache[7] || (_cache[7] =
                                                                            //@ts-ignore
                                                                            (...args) => (_unref(openFileDialog) && _unref(openFileDialog)(...args)))
                                                                    }, [
                                                                        _createElementVNode("img", {
                                                                            class: "campaign-email-form__load-file-icon",
                                                                            src: _imports_0,
                                                                            alt: _ctx.$t('_download')
                                                                        }, null, 8, _hoisted_47),
                                                                        _createTextVNode(_toDisplayString(_unref(t)('campaigns.create.search-file')), 1)
                                                                    ])
                                                                ]),
                                                                _createElementVNode("div", _hoisted_48, [
                                                                    _createElementVNode("button", {
                                                                        type: "button",
                                                                        class: "insert-button__button",
                                                                        disabled: !canInsertHtml.value,
                                                                        onClick: insertHtml
                                                                    }, _toDisplayString(_unref(t)('campaigns.create.insert-html')), 9, _hoisted_49)
                                                                ])
                                                            ]))
                                                            : (isLinkCreation.value)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                                    _createElementVNode("div", _hoisted_51, [
                                                                        _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.fields.html-url-label')), 1),
                                                                        _createVNode(_component_el_input, {
                                                                            modelValue: _unref(htmlUrl),
                                                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => (_isRef(htmlUrl) ? (htmlUrl).value = $event : null)),
                                                                            placeholder: _ctx.$t('breadcrumb.email.campaign-form.fields.html-url-placeholder'),
                                                                            disabled: _unref(loadingHtml)
                                                                        }, null, 8, ["modelValue", "placeholder", "disabled"])
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_53, [
                                                                        _createElementVNode("button", {
                                                                            type: "button",
                                                                            class: "insert-button__button",
                                                                            disabled: !canInsertHtml.value,
                                                                            onClick: insertHtml
                                                                        }, _toDisplayString(_unref(t)('campaigns.create.insert-html')), 9, _hoisted_54)
                                                                    ])
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                    ], 2))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_55, [
                                            _createElementVNode("label", _hoisted_56, [
                                                _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.fields.preheader')), 1),
                                                _createVNode(_component_el_input, {
                                                    modelValue: _unref(state).settings.preheader,
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(state).settings.preheader) = $event)),
                                                    placeholder: _ctx.$t('breadcrumb.email.campaign-form.fields.preheader-placeholder'),
                                                    maxlength: "30"
                                                }, null, 8, ["modelValue", "placeholder"])
                                            ]),
                                            _createElementVNode("div", _hoisted_58, [
                                                _createElementVNode("span", _hoisted_59, [
                                                    _createElementVNode("span", _hoisted_60, [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.fields.sender-email')) + " ", 1),
                                                        _createVNode(_component_el_tooltip, {
                                                            placement: "top",
                                                            "popper-class": "campaign-email-form__sender-tooltip"
                                                        }, {
                                                            content: _withCtx(() => [
                                                                _createElementVNode("span", _hoisted_61, [
                                                                    _createTextVNode(_toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.tooltips.sender-email.description')) + " ", 1),
                                                                    _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.tooltips.sender-email.warning')), 1)
                                                                ])
                                                            ]),
                                                            default: _withCtx(() => [
                                                                _hoisted_63
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _createVNode(_component_el_checkbox, {
                                                        modelValue: useDifferentReplyEmail.value,
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((useDifferentReplyEmail).value = $event)),
                                                        class: "campaign-email-form__checkbox"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.fields.use-different-reply')), 1)
                                                        ]),
                                                        _: 1
                                                    }, 8, ["modelValue"])
                                                ]),
                                                _createElementVNode("div", _hoisted_64, [
                                                    _withDirectives(_createVNode(_component_el_input, {
                                                        modelValue: senderEmailLocalPart.value,
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((senderEmailLocalPart).value = $event)),
                                                        modelModifiers: { trim: true },
                                                        placeholder: _ctx.$t('breadcrumb.email.campaign-form.fields.sender-email-placeholder'),
                                                        class: _normalizeClass({ 'input-error': senderEmailHasError.value }),
                                                        onBlur: handleSenderEmailBlur
                                                    }, null, 8, ["modelValue", "placeholder", "class"]), [
                                                        [
                                                            _directive_tooltip,
                                                            {
                                                                theme: 'error',
                                                                shown: senderEmailTooltipShown.value,
                                                                content: senderEmailTooltipContent.value,
                                                                distance: 8,
                                                                autoHide: false,
                                                            },
                                                            void 0,
                                                            { right: true }
                                                        ]
                                                    ]),
                                                    _createElementVNode("div", {
                                                        class: "campaign-email-form__domain-select-container",
                                                        onClick: _cache[13] || (_cache[13] = _withModifiers(() => { }, ["stop"])),
                                                        onMousedown: _cache[14] || (_cache[14] = _withModifiers(() => { }, ["stop"]))
                                                    }, [
                                                        _createVNode(_unref(vSelect), {
                                                            class: _normalizeClass([
                                                                'campaign-email-form__select',
                                                                'campaign-email-form__domain-select',
                                                                { 'select-error': senderEmailDomainHasError.value },
                                                            ]),
                                                            modelValue: senderEmailDomain.value,
                                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((senderEmailDomain).value = $event)),
                                                            options: domainOptions.value,
                                                            label: "label",
                                                            reduce: option => option.value,
                                                            placeholder: _ctx.$t('breadcrumb.email.campaign-form.fields.domain-placeholder'),
                                                            clearable: false,
                                                            searchable: false,
                                                            disabled: isSingleDomain.value
                                                        }, {
                                                            "open-indicator": _withCtx(({ attributes }) => [
                                                                _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                                                            ]),
                                                            "no-options": _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_unref(t)('no-results')), 1)
                                                            ]),
                                                            _: 1
                                                        }, 8, ["class", "modelValue", "options", "reduce", "placeholder", "disabled"])
                                                    ], 32)
                                                ])
                                            ]),
                                            (useDifferentReplyEmail.value)
                                                ? (_openBlock(), _createElementBlock("label", _hoisted_65, [
                                                    _createElementVNode("span", _hoisted_66, [
                                                        _createElementVNode("span", _hoisted_67, [
                                                            _createTextVNode(_toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.fields.reply-email')) + " ", 1),
                                                            _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_68, [
                                                                _createTextVNode("*")
                                                            ])), [
                                                                [
                                                                    _directive_tooltip,
                                                                    {
                                                                        theme: 'error',
                                                                        shown: replyToEmailRequiredTooltipShown.value,
                                                                        content: replyToEmailRequiredTooltipContent.value,
                                                                        distance: 8,
                                                                        autoHide: false,
                                                                    },
                                                                    void 0,
                                                                    { right: true }
                                                                ]
                                                            ])
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_69, [
                                                        _withDirectives(_createVNode(_component_el_input, {
                                                            modelValue: replyToEmailLocalPart.value,
                                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((replyToEmailLocalPart).value = $event)),
                                                            modelModifiers: { trim: true },
                                                            placeholder: _ctx.$t('breadcrumb.email.campaign-form.fields.reply-email-placeholder'),
                                                            maxlength: "70",
                                                            class: _normalizeClass({ 'input-error': replyToEmailHasError.value }),
                                                            onBlur: handleReplyToEmailBlur
                                                        }, null, 8, ["modelValue", "placeholder", "class"]), [
                                                            [
                                                                _directive_tooltip,
                                                                {
                                                                    theme: 'error',
                                                                    shown: replyToEmailTooltipShown.value,
                                                                    content: replyToEmailTooltipContent.value,
                                                                    distance: 8,
                                                                    autoHide: false,
                                                                },
                                                                void 0,
                                                                { right: true }
                                                            ]
                                                        ]),
                                                        _createElementVNode("div", {
                                                            class: "campaign-email-form__domain-select-container",
                                                            onClick: _cache[17] || (_cache[17] = _withModifiers(() => { }, ["stop"])),
                                                            onMousedown: _cache[18] || (_cache[18] = _withModifiers(() => { }, ["stop"]))
                                                        }, [
                                                            _createVNode(_unref(vSelect), {
                                                                class: _normalizeClass([
                                                                    'campaign-email-form__select',
                                                                    'campaign-email-form__domain-select',
                                                                    { 'select-error': replyToEmailDomainHasError.value },
                                                                ]),
                                                                modelValue: replyToEmailDomain.value,
                                                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((replyToEmailDomain).value = $event)),
                                                                options: domainOptions.value,
                                                                label: "label",
                                                                reduce: option => option.value,
                                                                placeholder: _ctx.$t('breadcrumb.email.campaign-form.fields.domain-placeholder'),
                                                                clearable: false,
                                                                searchable: false,
                                                                disabled: isSingleDomain.value
                                                            }, {
                                                                "open-indicator": _withCtx(({ attributes }) => [
                                                                    _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                                                                ]),
                                                                "no-options": _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(_unref(t)('no-results')), 1)
                                                                ]),
                                                                _: 1
                                                            }, 8, ["class", "modelValue", "options", "reduce", "placeholder", "disabled"])
                                                        ], 32)
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (isLoadingIps.value)
                                                ? (_openBlock(), _createElementBlock("label", _hoisted_70, [
                                                    _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.fields.ip-selection')), 1),
                                                    _createVNode(_unref(vSelect), {
                                                        class: _normalizeClass(['campaign-email-form__select']),
                                                        modelValue: _unref(state).settings.ipPoolName,
                                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_unref(state).settings.ipPoolName) = $event)),
                                                        options: ipStrategyOptions.value,
                                                        label: "label",
                                                        reduce: option => option.value,
                                                        placeholder: _ctx.$t('breadcrumb.email.campaign-form.fields.ip-balance-placeholder'),
                                                        clearable: true
                                                    }, {
                                                        "open-indicator": _withCtx(({ attributes }) => [
                                                            _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                                                        ]),
                                                        "no-options": _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_unref(t)('no-results')), 1)
                                                        ]),
                                                        _: 1
                                                    }, 8, ["modelValue", "options", "reduce", "placeholder"])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_72, [
                                        _createElementVNode("div", _hoisted_73, [
                                            _createElementVNode("span", _hoisted_74, [
                                                _createTextVNode("Template "),
                                                _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_75, [
                                                    _createTextVNode("*")
                                                ])), [
                                                    [
                                                        _directive_tooltip,
                                                        {
                                                            theme: 'error',
                                                            shown: fieldErrors.value.template !== '',
                                                            content: fieldErrors.value.template,
                                                            distance: 8,
                                                            autoHide: false,
                                                        },
                                                        void 0,
                                                        { right: true }
                                                    ]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["campaign-email-form__template", {
                                                    'campaign-email-form__template--full': isTemplateFullWidth.value,
                                                }])
                                        }, [
                                            _createElementVNode("div", _hoisted_76, [
                                                _createElementVNode("div", _hoisted_77, [
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: _normalizeClass(["campaign-email-form__mode-tab", { 'is-active': !isSourceMode.value }]),
                                                        onClick: _cache[20] || (_cache[20] = ($event) => (isSourceMode.value = false))
                                                    }, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.messages.preview-tab')), 3),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: _normalizeClass(["campaign-email-form__mode-tab", { 'is-active': isSourceMode.value }]),
                                                        onClick: _cache[21] || (_cache[21] = ($event) => (isSourceMode.value = true))
                                                    }, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.messages.source-tab')), 3)
                                                ]),
                                                (isSourceMode.value)
                                                    ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                                        key: 0,
                                                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_unref(state).settings.template) = $event)),
                                                        class: "campaign-email-form__source-textarea",
                                                        spellcheck: "false"
                                                    }, null, 512)), [
                                                        [_vModelText, _unref(state).settings.template]
                                                    ])
                                                    : (_openBlock(), _createElementBlock("div", {
                                                        key: 1,
                                                        class: "campaign-email-form__html-preview",
                                                        innerHTML: templateForPreview.value
                                                    }, null, 8, _hoisted_78))
                                            ]),
                                            (isHtmlCreation.value || !_unref(state).settings.creationType)
                                                ? (_openBlock(), _createElementBlock("aside", _hoisted_79, [
                                                    _createElementVNode("h3", _hoisted_80, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.messages.variables-title')), 1),
                                                    _createElementVNode("p", _hoisted_81, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.messages.variables-subtitle')), 1),
                                                    _createElementVNode("ul", _hoisted_82, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templateVariables.value, (variable) => {
                                                            return (_openBlock(), _createElementBlock("li", {
                                                                key: variable.value,
                                                                class: "campaign-email-form__variables-item"
                                                            }, [
                                                                _createElementVNode("span", _hoisted_83, _toDisplayString(variable.label), 1),
                                                                _createElementVNode("button", {
                                                                    type: "button",
                                                                    class: "campaign-email-form__variables-chip",
                                                                    draggable: "true",
                                                                    onDragstart: ($event) => (handleDragStart($event, variable.value))
                                                                }, _toDisplayString(variable.value), 41, _hoisted_84)
                                                            ]));
                                                        }), 128))
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ], 2)
                                    ])
                                ]),
                                _createElementVNode("section", _hoisted_85, [
                                    _createElementVNode("h2", _hoisted_86, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.sections.delivery')), 1),
                                    _createElementVNode("div", _hoisted_87, [
                                        _createElementVNode("div", _hoisted_88, [
                                            _createElementVNode("h4", _hoisted_89, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.delivery.type-title')), 1),
                                            _createElementVNode("div", _hoisted_90, [
                                                _createElementVNode("div", _hoisted_91, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        id: "campaign-email-delivery-type-one-time",
                                                        type: "radio",
                                                        name: "deliveryType",
                                                        value: false,
                                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_unref(state).settings.isRecurrent) = $event))
                                                    }, null, 512), [
                                                        [_vModelRadio, _unref(state).settings.isRecurrent]
                                                    ]),
                                                    _createElementVNode("label", _hoisted_92, [
                                                        _createElementVNode("span", _hoisted_93, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.delivery.one-time')), 1),
                                                        _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.delivery.one-time-description')), 1)
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_95, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        id: "campaign-email-delivery-type-recurrent",
                                                        type: "radio",
                                                        name: "deliveryType",
                                                        value: true,
                                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_unref(state).settings.isRecurrent) = $event))
                                                    }, null, 512), [
                                                        [_vModelRadio, _unref(state).settings.isRecurrent]
                                                    ]),
                                                    _createElementVNode("label", _hoisted_96, [
                                                        _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.delivery.recurrent')), 1),
                                                        _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.delivery.recurrent-description')), 1)
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_99, [
                                            _createElementVNode("h4", _hoisted_100, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.delivery.schedule-title')), 1),
                                            _createElementVNode("div", _hoisted_101, [
                                                (!_unref(state).settings.isRecurrent)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            id: "campaign-email-delivery-schedule-now",
                                                            type: "radio",
                                                            name: "deliverySchedule",
                                                            value: false,
                                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((_unref(state).settings.isScheduled) = $event))
                                                        }, null, 512), [
                                                            [_vModelRadio, _unref(state).settings.isScheduled]
                                                        ]),
                                                        _createElementVNode("label", _hoisted_103, [
                                                            _createElementVNode("span", _hoisted_104, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.delivery.send-now')), 1),
                                                            _createElementVNode("span", _hoisted_105, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.delivery.send-now-description')), 1)
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_106, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        id: "campaign-email-delivery-schedule-later",
                                                        type: "radio",
                                                        name: "deliverySchedule",
                                                        value: true,
                                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_unref(state).settings.isScheduled) = $event))
                                                    }, null, 512), [
                                                        [_vModelRadio, _unref(state).settings.isScheduled]
                                                    ]),
                                                    _createElementVNode("label", _hoisted_107, [
                                                        _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.delivery.schedule')), 1),
                                                        _createElementVNode("span", _hoisted_109, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.delivery.schedule-description')), 1)
                                                    ])
                                                ])
                                            ]),
                                            (_unref(state).settings.isScheduled)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                                    _createElementVNode("label", _hoisted_111, [
                                                        _createElementVNode("span", _hoisted_112, [
                                                            _createTextVNode(_toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.fields.send-date')) + " ", 1),
                                                            _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_113, [
                                                                _createTextVNode("*")
                                                            ])), [
                                                                [
                                                                    _directive_tooltip,
                                                                    {
                                                                        theme: 'error',
                                                                        shown: Boolean(fieldErrors.value.scheduleDate),
                                                                        content: fieldErrors.value.scheduleDate,
                                                                        distance: 8,
                                                                        autoHide: false,
                                                                    },
                                                                    void 0,
                                                                    { right: true }
                                                                ]
                                                            ])
                                                        ]),
                                                        _withDirectives(_createVNode(_component_el_date_picker, {
                                                            modelValue: _unref(state).settings.scheduleDate,
                                                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((_unref(state).settings.scheduleDate) = $event)),
                                                            type: "date",
                                                            "value-format": "YYYY-MM-DD",
                                                            format: "DD MMM YYYY",
                                                            placeholder: _ctx.$t('breadcrumb.email.campaign-form.fields.date-placeholder'),
                                                            class: _normalizeClass(["campaign-email-form__date-picker", { 'input-error': Boolean(fieldErrors.value.scheduleDate) }]),
                                                            "disabled-date": _unref(disabledBackwardDates)
                                                        }, null, 8, ["modelValue", "placeholder", "disabled-date", "class"]), [
                                                            [
                                                                _directive_tooltip,
                                                                {
                                                                    theme: 'error',
                                                                    shown: Boolean(fieldErrors.value.scheduleDate),
                                                                    content: fieldErrors.value.scheduleDate,
                                                                    distance: 8,
                                                                    autoHide: false,
                                                                },
                                                                void 0,
                                                                { right: true }
                                                            ]
                                                        ])
                                                    ]),
                                                    _createElementVNode("label", _hoisted_114, [
                                                        _createElementVNode("span", _hoisted_115, [
                                                            _createTextVNode(_toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.fields.send-time')) + " ", 1),
                                                            _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_116, [
                                                                _createTextVNode("*")
                                                            ])), [
                                                                [
                                                                    _directive_tooltip,
                                                                    {
                                                                        theme: 'error',
                                                                        shown: Boolean(fieldErrors.value.scheduleTime),
                                                                        content: fieldErrors.value.scheduleTime,
                                                                        distance: 8,
                                                                        autoHide: false,
                                                                    },
                                                                    void 0,
                                                                    { right: true }
                                                                ]
                                                            ])
                                                        ]),
                                                        _withDirectives(_createVNode(_component_el_time_picker, {
                                                            modelValue: _unref(state).settings.scheduleTime,
                                                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((_unref(state).settings.scheduleTime) = $event)),
                                                            format: "HH:mm",
                                                            "value-format": "HH:mm",
                                                            placeholder: _ctx.$t('breadcrumb.email.campaign-form.fields.time-placeholder'),
                                                            class: _normalizeClass(["campaign-email-form__time-picker", { 'input-error': Boolean(fieldErrors.value.scheduleTime) }]),
                                                            "disabled-hours": disabledHours,
                                                            "disabled-minutes": disabledMinutes
                                                        }, null, 8, ["modelValue", "placeholder", "class"]), [
                                                            [
                                                                _directive_tooltip,
                                                                {
                                                                    theme: 'error',
                                                                    shown: Boolean(fieldErrors.value.scheduleTime),
                                                                    content: fieldErrors.value.scheduleTime,
                                                                    distance: 8,
                                                                    autoHide: false,
                                                                },
                                                                void 0,
                                                                { right: true }
                                                            ]
                                                        ])
                                                    ]),
                                                    (_unref(state).settings.isRecurrent)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_117, _toDisplayString(_ctx.$t('breadcrumb.email.campaign-form.delivery.recurrent-schedule-note')), 1))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ]),
                                _createElementVNode("footer", _hoisted_118, [
                                    _createElementVNode("div", _hoisted_119, [
                                        (isEdit.value)
                                            ? (_openBlock(), _createBlock(_component_el_button, {
                                                key: 0,
                                                type: "default",
                                                class: "campaign-email-form__button campaign-email-form__button--back",
                                                disabled: _unref(state).saving,
                                                onClick: handleCancel
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("img", {
                                                        class: "campaign-email-form__button-back-icon",
                                                        src: require('@/assets/svgs/arrow-left.svg'),
                                                        alt: "",
                                                        "aria-hidden": "true"
                                                    }, null, 8, _hoisted_120),
                                                    _createElementVNode("span", _hoisted_121, _toDisplayString(_unref(t)('go-back')), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["disabled"]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_122, [
                                        _createVNode(_component_el_button, {
                                            type: "default",
                                            class: "campaign-email-form__button campaign-email-form__button--test",
                                            disabled: _unref(state).saving,
                                            onClick: sendEmailTest
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                    src: _unref(sendEmailTestIcon),
                                                    alt: "",
                                                    class: "campaign-email-form__button-icon",
                                                    width: "16",
                                                    height: "16"
                                                }, null, 8, _hoisted_123),
                                                _createTextVNode(" " + _toDisplayString(_unref(t)('breadcrumb.email.campaign.send-email-test')), 1)
                                            ]),
                                            _: 1
                                        }, 8, ["disabled"]),
                                        (!isEdit.value)
                                            ? (_openBlock(), _createBlock(_component_el_button, {
                                                key: 0,
                                                type: "primary",
                                                class: "campaign-email-form__button",
                                                "native-type": "submit",
                                                loading: _unref(state).saving,
                                                disabled: _unref(state).saving
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(t)('campaigns.create.create-campaign')), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["loading", "disabled"]))
                                            : _createCommentVNode("", true),
                                        (isEdit.value)
                                            ? (_openBlock(), _createBlock(_component_el_button, {
                                                key: 1,
                                                type: "primary",
                                                class: "campaign-email-form__button",
                                                loading: _unref(state).saving,
                                                disabled: _unref(state).saving,
                                                onClick: handleSubmit
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(t)('campaigns.create.save-changes')), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["loading", "disabled"]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createVNode(SendTestEmailDialog, {
                                    modelValue: _unref(isTestEmailModalOpen),
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => (_isRef(isTestEmailModalOpen) ? (isTestEmailModalOpen).value = $event : null)),
                                    "campaign-title": _unref(state).settings.title,
                                    template: _unref(testTemplateForModal),
                                    preheader: _unref(state).settings.preheader,
                                    "sender-email": _unref(state).settings.senderEmail || brandSenderEmail.value,
                                    "sender-name": _unref(state).settings.senderName || brandSenderName.value,
                                    "reply-to-email": _unref(state).settings.replyToEmail || _unref(state).settings.senderEmail || brandSenderEmail.value
                                }, null, 8, ["modelValue", "campaign-title", "template", "preheader", "sender-email", "sender-name", "reply-to-email"])
                            ], 40, _hoisted_9))
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
